function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled, { css } from 'styled-components';
import Loader from '../../loader';
import { primary50, primary500, primary600, primary700, white, gray100, gray200, gray300, gray400, gray800, gray900, focusShadow } from '../../theme/colors';
import { duration300, easeInOut } from '../../theme/animation';
import { fontSemiBold } from '../../theme/fonts';
import { elevationFive } from '../../theme/elevations';
const BaseButton = styled.button`
  ${({
  block
}) => block && 'width: 100%;'}
  background: transparent;
  border: 1px solid transparent;
  color: ${gray900};
  font-family: ${fontSemiBold};
  margin: 0;
  overflow: visible;
  text-align: center;
  text-decoration: none;
  transition: box-shadow ${duration300} ${easeInOut}, background ${duration300} ${easeInOut};
  vertical-align: middle;
  white-space: normal;

  &:hover {
    box-shadow: ${elevationFive};
    cursor: pointer
  }

  &:focus {
    box-shadow: 0 0 0 3px ${focusShadow};
    outline: none;
  }

  ${({
  disabled,
  $loading
}) => disabled && !$loading && css`
    &&, &&:hover, &&:focus {
      pointer-events: none;
      background: ${gray100};
      border-color: ${gray200};
      color: ${gray400};
    }
  `}
`;
const PrimaryButton = styled(BaseButton)`
  background: ${primary600};
  color: ${white};

  &:hover {
    background: ${primary500};
  }

  &:active {
    background: ${primary700};
  }
`;
const SecondaryButton = styled(BaseButton)`
  border-color: ${primary600};
  color: ${primary600};

  &:hover {
    border-color: ${primary500};
  }

  &:active {
    background: ${primary50};
    border-color: ${primary700};
  }
`;
const TextButton = styled(BaseButton)`
  color: ${primary600};

  &:hover {
    background: ${white};
  }

  &:active {
    background: ${primary50};
  }

  ${({
  disabled,
  $loading
}) => disabled && !$loading && css`
    &&, &&:hover, &&:focus {
      background: transparent;
      border: 0;
    }
  `}
`;
const BasicButton = styled(BaseButton)`
  border-color: ${gray300};
  color: ${gray800};

  &:hover {
    border-color: ${gray400};
  }

  &:active {
    background: ${gray100};
  }
`;
export const BUTTON_VARIANTS = {
  primary: PrimaryButton,
  secondary: SecondaryButton,
  tertiary: TextButton,
  base: BasicButton
};
export const ButtonWrapper = ({
  children,
  onClick,
  variant = 'primary',
  loaderSize,
  label,
  loading = false,
  disabled = false,
  block = false,
  id,
  ...props
}) => {
  const Wrapper = BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.base;
  const loadingAttributes = loading && {
    'aria-busy': true,
    'aria-label': 'Loading'
  };
  const labelAttributes = label && {
    'aria-label': label
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onClick: onClick,
    disabled: disabled || loading,
    $loading: loading,
    block: block,
    id: id
  }, loadingAttributes, labelAttributes, props), loading ? /*#__PURE__*/React.createElement(Loader, {
    size: loaderSize
  }) : children);
};
export default ButtonWrapper;
//# sourceMappingURL=index.js.map